<template>
  <div class="column">
    <div class="row justify-end"><div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" outline @click.native="exportList('enveloppe')">{{$t('processes.export_enveloppe')}}</q-btn>
      </div>
      <!-- <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" outline @click.native="exportList('typeAide')">{{$t('processes.export_typeAide')}}</q-btn>
      </div>
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" outline @click.native="exportList('millesime')">{{$t('processes.export_millesime')}}</q-btn>
      </div> -->
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" outline @click.native="exportList('reglement')">{{$t('processes.export_reglement')}}</q-btn>
      </div>
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" outline @click.native="exportList()">{{$t('processes.export')}}</q-btn>
      </div>
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" :to="{ name: 'suivi-des-aides-admin-form' }" icon-right="add_circle">{{$t('processes.create_suivi_des_aides')}}</q-btn>
      </div>
    </div>
    <q-table flat wrap-cells
      :data="datas"
      :columns="columns"
      row-key="id"
      :rows-per-page-options="rowsPerPageOptions"
      :pagination.sync="pagination"
      :loading="loading"
      :filter="filter"
      @request="onRequest"
      binary-state-sort>
      <q-tr slot="body" slot-scope="props" :props="props"
        @click.native="$router.push({ name: 'suivi-des-aides-admin-form', params: { id: props.row.id } })"
        class="cursor-pointer">
        <q-td v-for="col in props.cols" :key="col.name" :props="props" :auto-width="col.autoWidth">
          <div v-if="col.value" v-html="col.value" />
        </q-td>
      </q-tr>
    </q-table>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import download from 'downloadjs'

export default {
  name: 'SuiviDesAidesList',

  preFetch ({ store, currentRoute, previousRoute, redirect, ssrContext }) {
    store.dispatch('processes/fetchFilters', 'aideAdmin')
  },

  meta () {
    return {
      title: 'Suivi des aides admins'
    }
  },

  data () {
    return {
      loading: false
    }
  },

  computed: {
    ...mapGetters({
      suiviDesAidesAdminProcesses: 'processes/getProcesses',
      filters: 'processes/getFilters',
      rowsPerPageOptions: 'config/getRowsPerPageOptions'
    }),
    pagination: {
      ...mapGetters({ get: 'processes/getPagination' }),
      ...mapMutations({ set: 'processes/setPagination' })
    },
    filter () {
      return this.$route.meta.filter
    },

    datas () {
      return this.suiviDesAidesAdminProcesses.map(process => ({
        id: process.id,
        region: process.region,
        type_aide_id: process.type_aide,
        millesime_id: process.millesime,
        statut: process.statut
      }))
    },

    columns () {
      if (this.suiviDesAidesAdminProcesses.length === 0) return []
      else {
        const fields = ['region', 'type_aide_id', 'millesime_id', 'statut']
        const sortable = ['type_aide_id', 'millesime_id']

        return fields.map(key => {
          let label = this.$t(`processes.fields.${key}.label`)
          let align = 'left'
          let autoWidth = false
          let formatFn = val => val

          if (key === 'type_aide_id') {
            formatFn = val => val ? val.label : ''
          } else if (key === 'region') {
            formatFn = val => val ? val.label : ''
          } else if (key === 'millesime_id') {
            formatFn = val => val ? val.millesime : ''
          } else if (key === 'statut') {
            formatFn = val => val ? this.$t(`processes.status.${val}`) : ''
            align = 'center'
          }

          return {
            name: key,
            align: align,
            label: label,
            field: key,
            format: formatFn,
            sortable: sortable.indexOf(key) >= 0,
            autoWidth: autoWidth
          }
        })
      }
    }
  },

  watch: {
    filters: {
      handler (newVal, oldVal) {
        this.onRequest({ pagination: this.pagination })
      },
      deep: true
    },
    '$route.meta.filter': {
      handler (newVal, oldVal) {
        this.onRequest({ pagination: this.pagination })
      },
      deep: true
    }
  },

  mounted () {
    // if (this.filters) {
    this.onRequest({ pagination: this.pagination })
    // }
    this.$store.commit('pages/setBreadcrumbs', [
      { label: this.$t('global.home'), to: { name: 'home' }, icon: 'home' },
      { label: this.$t('processes.processAgence'), to: { name: '' } },
      { label: this.$t('processes.title.suivi_des_aides_admin'), to: { name: 'suivi-des-aides-admin-en-cours' } },
      {}
    ])

    this.$store.commit('pages/setPageTitle', this.$t('processes.title.suivi_des_aides_admin'))
    this.$store.commit('pages/setTabs', [
      { name: 'suivi-des-aides-admin-en-cours', label: 'En cours', to: { name: 'suivi-des-aides-admin-en-cours' } },
      { name: 'suivi-des-aides-admin-archivés', label: 'Archivés', to: { name: 'suivi-des-aides-admin-archives' } }
    ])
  },

  methods: {
    onRequest ({ pagination, filter }) {
      this.$store.commit('processes/setPagination', pagination)
      this.loading = true

      let params = { ...pagination, filter: this.filter, typeProcess: 'aide-admin' }
      if (this.filters) this.filters.forEach(filter => { params[filter.id] = filter.value })

      this.$store.dispatch('processes/fetchProcesses', params)
        .finally(() => { this.loading = false })
    },

    exportList (process) {
      let toExport = process || 'aide-admin'
      this.$axios.get(`/api/processAgences/${toExport}/export`, {
        responseType: 'arraybuffer',
        headers: { 'Content-Type': 'text/csv' }
      }).then(response => {
        download(response.data, `${toExport}.csv`)
      }).catch(this.$notifyError)
    }
  }
}
</script>
